<template>
   <section class="homecategories">
      <div class="container">
         <div class="homecategories__title">
            <h4>less time <span>planning</span> and more time <span>doing.</span></h4>
            <p>Witness magical oceanside sunsets 12 floors up at Rocco, lounge poolside with our signature Revitaliser cocktail or spend the day with hundreds of the newest movies to enjoy in your room or suite. Whatever you decide, there’s no wrong way to live in the moment at Crystalbrook Riley.</p>
         </div>
         <div class="homecategories__wrap">
            
            <a class="homecategories__item" @click='navigate(cat)' v-for="cat in category" :key="cat.id">
               <div class="homecategories__item-img" v-bind:style="{ background: 'url(' + cat.linkAvatar + ')' + 'no-repeat center center' }"></div>
               <div class="homecategories__item-content">
                  <h5 href="#">{{ cat.linkText }}</h5>
               </div>
            </a>

         </div>
      </div>
   </section>
</template>

<script>
   import { CATEGORIES } from '../js/categories.js';

   export default {
      name: 'HomeCategories',
      data: function() {
         return {
            category: CATEGORIES
         }
      },

      methods: {
         navigate (cat) {
            let params = { urlSegment: cat.urlSegment, id: cat.id, screenId: this.$router.currentRoute.params.screenId }
            this.$router.push({ name: 'category', params: params})
         }
      },
   }
</script>
